module.exports = __webpack_public_path__ + "img/np-warning-940614-000000-2.d1bc0dd6.svg";